<template>
  <layout :title="$t(`reset.title`)" :desc="$t(`reset.desc`)">
    <div class="alert alert-danger" role="alert" v-if="error">
      {{$t(`reset.error`)}}
    </div>
    <div class="alert alert-success" role="alert" v-if="sent">
      {{$t(`reset.sent`)}}
    </div>
    <form @submit.prevent="reset" v-if="!sent">
      <input class="form-control" type="email" v-model="email" :placeholder="$t(`login.email`)" required :disabled="loading">
      <div class="form-button full-width">
        <button id="submit" type="submit" class="ibtn btn-forget" :disabled="loading" style="width: 100%;">{{$t(`reset.send`)}}</button>
      </div>
    </form>
    <div class="other-links">
      <router-link :to="{ name: `Login` }">{{$t(`reset.backToLogin`)}}</router-link>
    </div>
  </layout>
</template>

<script>
import Layout from './Layout';

export default {
  name: "Reset",
  components: {
    Layout,
  },
  data: () => ({
    email: ``,
    loading: false,
    sent: false,
    error: false,
  }),
  methods: {
    async reset () {
      this.error = false;
      this.loading = true;
      if (await this.$store.dispatch(`resetPassword`, this.email)) {
        this.sent = true;
      } else {
        this.error = true;
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>

</style>
